import { SelectProps } from '@round/ui-kit';
import { PurchaseOrderOption } from '../../../hooks/usePurchaseOrderSelect';
import { Select } from '@round/whitelabel-ui';
import PurchaseOrderOptionLabel from './PurchaseOrderOptionLabel/PurchaseOrderOptionLabel';

type Props = SelectProps<PurchaseOrderOption>;

const PurchaseOrderSelect = (props: Props) => (
    <Select
        {...props}
        isMulti={false}
        menuPortalTarget={null}
        formatOptionLabel={(option, meta) => {
            if (meta.context === 'value') {
                return option.label;
            }

            // Select seems to always return a multiple value array here
            const selectedValue = (Array.isArray(meta.selectValue) ? meta.selectValue : [meta.selectValue])[0]?.value;

            return <PurchaseOrderOptionLabel option={option} isSelected={selectedValue === option.value} />;
        }}
    />
);

export default PurchaseOrderSelect;
